// scroll reveal
  const io=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
  },{threshold:.12,rootMargin:'0px 0px -60px 0px'});
  document.querySelectorAll('.reveal,.stagger').forEach(el=>io.observe(el));

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item=>{
    const q=item.querySelector('.faq-q');
    const a=item.querySelector('.faq-a');
    q.addEventListener('click',()=>{
      const open=item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i=>{
        i.classList.remove('open');
        i.querySelector('.faq-a').style.maxHeight=null;
        i.querySelector('.faq-q').setAttribute('aria-expanded','false');
      });
      if(!open){item.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';q.setAttribute('aria-expanded','true');}
    });
  });

  // count-up stats
  const counters=document.querySelectorAll('.num[data-count]');
  const cio=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(!e.isIntersecting)return;
      const el=e.target;cio.unobserve(el);
      if(el.dataset.lit){el.textContent=el.dataset.lit;return;}
      const end=parseFloat(el.dataset.count);
      const dec=parseInt(el.dataset.dec||'0');
      const suffix=el.dataset.suffix||'';
      const dur=1600;const t0=performance.now();
      const fmt=(n)=>dec>0?n.toFixed(dec):Math.round(n).toLocaleString();
      const tick=(t)=>{
        const p=Math.min((t-t0)/dur,1);
        const eased=1-Math.pow(1-p,3);
        el.textContent=fmt(end*eased)+suffix;
        if(p<1)requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  },{threshold:.5});
  counters.forEach(c=>cio.observe(c));

  // card spotlight microinteraction
  document.querySelectorAll('.card').forEach(card=>{
    card.addEventListener('pointermove',e=>{
      const r=card.getBoundingClientRect();
      card.style.setProperty('--mx',((e.clientX-r.left)/r.width*100)+'%');
      card.style.setProperty('--my',((e.clientY-r.top)/r.height*100)+'%');
    });
  });

  // organic equalizer
  document.querySelectorAll('.wave i').forEach(bar=>{
    bar.style.animationDuration=(1.1+Math.random()*0.8)+'s';
  });

  // audio preview player
  (function(){
    const player=document.getElementById('player');
    const audio=document.getElementById('previewAudio');
    const btn=document.getElementById('playBtn');
    const fill=document.getElementById('playerFill');
    const bar=document.getElementById('playerBar');
    const cur=document.getElementById('playerCur');
    const dur=document.getElementById('playerDur');
    const icPlay=btn.querySelector('.ic-play');
    const icPause=btn.querySelector('.ic-pause');
    if(!audio)return;
    const fmt=s=>{s=Math.max(0,Math.floor(s||0));return Math.floor(s/60)+':'+String(s%60).padStart(2,'0')};
    audio.addEventListener('loadedmetadata',()=>{if(isFinite(audio.duration))dur.textContent=fmt(audio.duration)});
    audio.addEventListener('timeupdate',()=>{
      const d=audio.duration||60;
      fill.style.width=Math.min(100,(audio.currentTime/d)*100)+'%';
      cur.textContent=fmt(audio.currentTime);
    });
    const setPlaying=on=>{
      player.classList.toggle('playing',on);
      icPlay.style.display=on?'none':'';
      icPause.style.display=on?'':'none';
      btn.setAttribute('aria-label',on?'Pause preview':'Play 1-minute preview');
    };
    btn.addEventListener('click',()=>{
      if(audio.paused){audio.play();}else{audio.pause();}
    });
    audio.addEventListener('play',()=>setPlaying(true));
    audio.addEventListener('pause',()=>setPlaying(false));
    audio.addEventListener('ended',()=>{setPlaying(false);fill.style.width='0%';cur.textContent='0:00';audio.currentTime=0;});
    bar.addEventListener('click',e=>{
      const r=bar.getBoundingClientRect();
      const d=audio.duration||60;
      audio.currentTime=Math.min(d,Math.max(0,(e.clientX-r.left)/r.width*d));
    });
  })();